<template>
  <div class="relative w-full">
    <input v-model="search" @input="filterCustomers" @click="isOpen = true" :autofocus="autofocus" type="search" class="w-full text-xl placeholder:text-lg" placeholder="Search for a Customer">
    <ul v-if="isOpen" class="absolute w-full py-1 overflow-y-auto text-lg bg-gray-100 rounded-lg shadow-md space-y-1 max-h-56">
      <li v-for="(c, index) in filtered" :key="c.id" @click="selectCustomer(index)" class="px-2 py-1 hover:bg-gray-200">
        <p>{{ c.name }}</p>
        <div class="flex justify-between text-base leading-none text-gray-400"><span>#{{ c.id }}</span> <span>Rs.{{ c.wallet_balance }}</span></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CustomerSearch',

  props: {
    autofocus: { type: Boolean, default: false },
    customers: { type: Array, required: true, default: [] },
    modelValue: [String, Number],
  },

  data() {
    return {
      isOpen: false,
      search: '',
      filtered: [],
    };
  },

  watch: {
    modelValue(newVal) {
      if (newVal != null && newVal != '') {
        let searchCustomer = this.customers.filter(c => c.id == newVal);
        if (searchCustomer.length != 0) this.search = searchCustomer[0]['name'];
        this.filterCustomers();
      }
    }
  },

  methods: {
    filterCustomers() {
      if (this.search == null || this.search == '') {
        this.filtered = this.customers;
      } else {
        this.filtered = this.customers.filter(c => JSON.stringify(c).toLowerCase().includes(this.search.toLowerCase()));
      }
    },

    selectCustomer(index) {
      this.search = this.filtered[index].name;
      this.$emit('update:modelValue', this.filtered[index].id);
      this.isOpen = false;
    },
  },

  created() {
    this.customers.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    this.filtered = this.customers;
    if (this.modelValue != null && this.modelValue != '') {
      let searchCustomer = this.customers.filter(c => c.id == this.modelValue);
      if (searchCustomer.length != 0) this.search = searchCustomer[0]['name'];
      this.filterCustomers();
    } else {
      this.isOpen = true;
    }
  },
}
</script>
